var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"root-container"},[_c('Header',{attrs:{"display-search-icon":_vm.displaySearchIcon}}),_c('TemplateContent',{staticClass:"template-content-container"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }